import { api } from '../../../lib/api'

export const GET_AVAILABLE_DOMAIN_SUBSCRIPTIONS_REQUEST = 'GET_AVAILABLE_DOMAIN_SUBSCRIPTIONS_REQUEST'
export const GET_AVAILABLE_DOMAIN_SUBSCRIPTIONS_SUCCESS = 'GET_AVAILABLE_DOMAIN_SUBSCRIPTIONS_SUCCESS'
export const GET_AVAILABLE_DOMAIN_SUBSCRIPTIONS_FAILED = 'GET_AVAILABLE_DOMAIN_SUBSCRIPTIONS_FAILED'

export const getRegisterSubscriptions = function (onGetSubscriptions) {
  return function (dispatch) {
    dispatch({
      type: GET_AVAILABLE_DOMAIN_SUBSCRIPTIONS_REQUEST
    })
    api.getSubscriptions().then(getSubscriptionsResponse => {
      dispatch({
        type: GET_AVAILABLE_DOMAIN_SUBSCRIPTIONS_SUCCESS,
        payload: getSubscriptionsResponse
      })
      if (onGetSubscriptions) onGetSubscriptions()
    }).catch(error => {
      dispatch({
        type: GET_AVAILABLE_DOMAIN_SUBSCRIPTIONS_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/register-flow/register-payment-plans.js